import { Button, createTheme } from '@mantine/core';

export const theme = createTheme({
  components: {
    Button: Button.extend({
      vars: (_, props) => {
        if (props.size === 'xl') {
          return {
            root: {
              '--button-fz': '16px',
              '--button-height': '81px',
              '--button-padding-x': '45px',
            },
          };
        }
        if (props.size === 'lg') {
          return {
            root: {
              '--button-fz': '14px',
              '--button-height': '56px',
              '--button-padding-x': '32px',
            },
          };
        }
        if (props.size === 'md') {
          return {
            root: {
              '--button-fz': '14px',
              '--button-height': '49px',
              '--button-padding-x': '32px',
            },
          };
        }
        if (props.size === 'sm') {
          return {
            root: {
              '--button-fz': '14px',
              '--button-height': '36px',
              '--button-padding-x': '12px',
            },
          };
        }
        return { root: {} };
      },
    }),
  },
});
